<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">会员积分规则</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">会员积分规则</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p class="c9">
                            <strong>一、什么是会员积分</strong>
                        </p>
                        <p>
                            <span>会员积分指注册会员在夜樱情趣商城上消费后参与相关抽奖活动或签到所获得的积分；会员积分可用于积分商城中产品的兑换。</span>
                        </p>
                        <p class="c9">
                            <strong>二、夜樱情趣商城会员特权优惠（注册即可成为会员）：</strong>
                        </p>
                        <p>
                            <span>注：在线支付包邮</span>
                        </p>
                        <p class="c9">
                            <strong>三、如何获得积分</strong>
                        </p>
                        <p>
                            <span>（一）如何获得消费积分<br></span>
                        </p>
                        <p>
                            <span>1.注册积分。</span>
                        </p>
                        <p>
                            <span>2.新手任务。</span>
                        </p>
                        <p>
                            <span>3.手机签到。</span>
                        </p>
                        <p>
                            <span>4.手机大转盘中奖</span>
                        </p>
                        <p class="c9">
                            <strong>四、如何查询我的积分和明细</strong>
                        </p>
                        <p>
                            <span>
                                <span>会员中心&gt;&gt;我的积分,</span>
                                <a target="_blank" href="/login">
                                    <span style="text-decoration:underline;">
                                        <span>立刻登陆查询
                                        </span>
                                    </span>
                                </a>
                            </span>
                        </p>
                        <p>
                            <span>
                                <span style="text-decoration:underline;"><br></span>
                            </span>
                        </p>
                        <p>
                            <span>亲，是否解决了您的疑问？如没有，请在线咨询。</span>
                        </p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30">&nbsp;</p>
                    <p class="bline"></p>
                    <p class="lh30">&nbsp;</p>
                    <p style="font-size:16px;">
                        <a href="/help/yingyezhizhao" style="float:left;">上一篇:执业执照</a>
                        <a href="/help/changjianwenti" class="pl10" style="float:right;">下一篇:常见问题</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/jifen.vue